import { useQuery } from '@tanstack/react-query';
import { legacyOrderQueries } from '../api/legacy-order-queries';
import type { LegacyOrdersQuery } from '../api/legacy-order-api';

/** The legacy orders list for the current filters. */
export const useLegacyOrders = (query: LegacyOrdersQuery) =>
  useQuery(legacyOrderQueries.list(query));

/**
 * One order for the detail drawer. Pass `null` when the drawer is closed —
 * the query then stays idle rather than fetching order 0.
 */
export const useLegacyOrderDetail = (id: number | null) =>
  useQuery({
    ...legacyOrderQueries.detail(id ?? 0),
    enabled: id !== null,
  });

/**
 * The courier's live position for the drawer map. Idle until a courier is
 * assigned, and stops polling once the order reaches stage 15 (delivered) —
 * the old drawer's exact gating.
 */
export const useLegacyCourierTracking = ({
  orderId,
  courierId,
  stage,
}: {
  orderId: number;
  courierId: number | null;
  stage: number;
}) =>
  useQuery({
    ...legacyOrderQueries.courierTracking({ orderId, courierId: courierId ?? 0 }),
    enabled: courierId !== null && stage !== 15,
  });
